import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    event.preventDefault()
    var form = document.getElementById(event.currentTarget.dataset.form)
    Turbo.navigator.submitForm(form)
  }
}
